import { render, staticRenderFns } from "./UserChart.vue?vue&type=template&id=033e2ff9&scoped=true&"
import script from "./UserChart.vue?vue&type=script&lang=js&"
export * from "./UserChart.vue?vue&type=script&lang=js&"
import style0 from "./UserChart.vue?vue&type=style&index=0&id=033e2ff9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e2ff9",
  null
  
)

export default component.exports